import { render, staticRenderFns } from "./Day22.vue?vue&type=template&id=79985333&"
import script from "./Day22.vue?vue&type=script&lang=js&"
export * from "./Day22.vue?vue&type=script&lang=js&"
import style0 from "./Day22.vue?vue&type=style&index=0&id=79985333&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports